import { ComponentProps, FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';

import { Badge } from 'dibs-elements/exports/Badge';

import styles from './styles.scss';

export type BadgeBackgroundColor = ComponentProps<typeof Badge>['backgroundColor'];

type Props = React.HTMLAttributes<HTMLDivElement> & {
    backgroundColor?: BadgeBackgroundColor;
};
export const NoReserve: FC<Props> = ({ backgroundColor, ...props }) => {
    return (
        <div
            {...props}
            className={classnames(styles.pillContainer, props.className)}
            data-tn="no-reserve"
        >
            <Badge type="pill" size="small-heavy" backgroundColor={backgroundColor}>
                <FormattedMessage id="dc.searchProductTile.noReserve" defaultMessage="No Reserve" />
            </Badge>
        </div>
    );
};
